const workflow = {
  stagedMode: '工程別に進める',
  quickMode: 'クイック実行',
  startTitle: '工程別ワークフロー',
  startDescription: '工程、入力、粒度を選んで中間成果物を保存しながら進めます。',
      cards: {
        accept: '採用',
        acceptanceCriteria: '合格基準',
        adoptContent: '内容を採用',
        aiCandidate: 'AI候補',
        aiExpectedEffect: 'AI期待効果 {{score}}',
        aiSeverityCandidate: 'AI重大度候補 {{score}}',
        cause: '原因',
        changeDescription: '変更内容',
        changeItem: '変更点 {{number}}',
        confidence: '信頼度 {{percent}}%',
        comparabilityConfirmed: '比較可能性確認済み: {{rationale}}',
        confirmComparability: '比較可能性を確認（実際の仕様変更）',
        confirmComparabilityHint: '旧新とも入力資料どおりで、基準・単位・項目の違いが実際の仕様変更であることを確認します。抜粋は検証済みの根拠にはなりません。',
        confirmationRationale: '確認の理由（必須）',
        submitConfirmation: '確認を記録',
        cancelConfirmation: 'キャンセル',
        confirmSod: 'S/O/Dを確定',
        confirmedEffect: '確認済み効果',
        countermeasure: '対策',
        countermeasureRequirement: '対策要否',
        defer: '保留',
        effect: '影響',
        failureMode: '故障モード',
        feasibility: '実現性',
        integrityHeld: '抽出の整合性確認のため保留中',
        integrityHint: '旧新の値を入力資料どおりに修正すると、理由が解消して採用できます。',
        integrityReasons: {
          old_not_in_input: '旧仕様の値が入力資料に見つかりません',
          new_not_in_input: '新仕様の値が入力資料に見つかりません',
          attribute_mismatch: '旧新で比較している項目が異なります',
          attribute_unverified: '旧新が同じ項目か入力資料から確認できません',
          unit_mismatch: '旧新の単位の次元が異なります（例: mm と kg）',
          different_basis: '旧新で比較の基準が異なります（例: 公称値と上下限値）',
          unit_unconvertible: '旧新の単位を決定的に換算できません',
          source_missing: '照合元の入力資料が見つかりません',
          unchanged: '旧新の値が同じで、変更がありません',
        },
        mechanism: '作用機序',
        needsInfo: '要確認',
        newSpecification: '新仕様',
        notRequired: '不要',
        notRequiredReason: '対策不要の理由',
        oldSpecification: '旧仕様',
        reject: '却下',
        required: '必要',
        requiredForSod: 'S/O/D確定に必須',
        scoringStatus: '採点: {{status}}',
        targetCause: '対象原因',
        unconfirmed: '未確認: {{items}}',
        verificationMethod: '検証方法',
      },
      input: {
        changeGranularityFieldLabel: '変更粒度',
        changeReportLabel: '変化点資料',
        description: 'この工程で使う旧新情報や変化点資料を登録します。',
        extractChanges: '変更点を抽出',
        granularityCoarse: '粗い粒度',
        granularityFine: '細かい粒度',
        granularityMixed: '混在',
        inputPatternChangeReport: '変化点資料',
        inputPatternFieldLabel: '入力パターン',
        inputPatternFunctionPartMatrix: '機能一覧 × 部品ツリー',
        inputPatternOldNewCad: '旧新CAD',
        inputPatternOldNewDocuments: '旧新ドキュメント',
        inputPatternOldNewDrawings: '旧新図面',
        newCadModelIdLabel: '新CADモデルID',
        newDrawingExtractedText: '新図面の抽出テキスト',
        newSpecLabel: '新仕様',
        oldCadModelIdLabel: '旧CADモデルID',
        oldDrawingExtractedText: '旧図面の抽出テキスト',
        oldSpecLabel: '旧仕様',
        phaseConceptEstimate: '構想・見積',
        phaseDetailedDesign: '詳細設計',
        phaseFieldLabel: '工程フェーズ',
        phaseFmeaDrbfm: 'FMEA/DRBFM',
        phasePostProcessCheck: '後工程確認',
        phaseRequirementsChange: '要求変更',
        startProcess: '工程を開始',
        title: '入力成果物',
      },
      errors: {
        analyzeInProgress: 'このセッションは分析中です。完了してから再実行してください',
        analysisInProgress: 'このセッションは分析中のため保存できませんでした。分析が終わってからもう一度保存してください',
        rerunBlocked: '確認・編集・手入力された行があるため再分析できません。レビュー画面で続けてください',
        supplementCopied: 'AI が生成した行に補足の文面がそのまま含まれていたため、その行は保存されず、分析は失敗しました。もう一度実行してください。続く場合は補足を言い換えてください。',
      },
      logic: {
        cadIdsRequired: '旧CAD IDと新CAD IDを入力してください',
        changeReportRequired: '変化点資料を入力してください',
        changeReportTitle: '変化点資料',
        drawingsTextRequired: '旧図面と新図面の抽出テキストを入力してください',
        extractChangesFailed: '変更点抽出に失敗しました',
        generateCountermeasuresFailed: '対策案生成に失敗しました',
        generateFailureModesFailed: '故障モード生成に失敗しました',
        newCadTitle: '新CAD',
        newDrawingTitle: '新図面',
        newSpecTitle: '新仕様',
        normalizeChangesFailed: '変更点の正規化に失敗しました',
        oldCadTitle: '旧CAD',
        oldDrawingTitle: '旧図面',
        oldSpecTitle: '旧仕様',
        sessionTitle: '{{itemName}} 工程別DRBFM',
        specsRequired: '旧仕様と新仕様を入力してください',
        stageRunFailed: 'DRBFM工程実行に失敗しました',
      },
      matrix: {
        affectedRequirements: '影響する機能要求',
        aiCandidate: '（候補: {{status}}）',
        aiDraft: 'AI下書き',
        cellJudgment: 'セル判定',
        changeSummary: '変化点要約',
        changedCount: '変更 {{count}}',
        excelImport: 'Excel取込',
        functionHierarchyHeader: '機能階層',
        gridAriaLabel: '変化点抽出マトリクス',
        importHint: '「機能一覧」と、部品階層（「部品ツリー」または「階層図」）、変化点（「変化点抽出マトリクス」または「変更点・変化点」）を含む .xlsx を取り込んでください。',
        importantChangedCount: '重要変化 {{count}}',
        importantNeedsRequirement: '重要変化は、影響する機能要求を1件以上選択してください。',
        importantWithoutRequirementsCount: '要求未指定 {{count}}',
        inspectionAxis: '点検軸',
        inspectionAxisHintHeader: '点検軸ヒント',
        judgment: '判定',
        newValue: '変更後',
        oldValue: '変更前',
        part: '部品',
        partNameHeader: '部品名',
        partNoHeader: '部品No.',
        partTreeAriaLabel: '部品ツリー',
        partTreeCount: '部品ツリー（{{count}}件）',
        promotedCannotEdit: 'このセルは設計変更へ昇格済みのため編集できません。',
        promotionRequirements: '昇格には全セルの確認と、変更ありセルが1件以上必要です。重要変化には影響要求も指定します。',
        requirementHeader: '要求',
        requirementListAriaLabel: '機能要求一覧',
        requirementsCount: '機能要求（{{count}}件）',
        reviewedCount: '確認 {{reviewed}}/{{total}}',
        reviewerNote: 'レビューメモ',
        roleHeader: '役割',
        saveJudgment: '判定を保存',
        shortChanged: 'あり',
        shortNone: 'なし',
        shortUnchecked: '未',
        shortUnknown: '不明',
        statusChanged: '変更あり',
        statusImportantChanged: '重要変化あり',
        statusNone: '変更なし',
        statusNotApplicable: '該当なし',
        statusUnchecked: '未確認',
        statusUnknown: '要確認・不明',
        uncheckedCount: '未確認 {{count}}',
        unitHeader: 'ユニット',
        unknownCount: '不明 {{count}}',
        workbenchDescription: '全セルを確認してから、変更ありセルだけをDRBFM設計変更へ送ります。',
        workbenchTitle: '機能一覧 × 部品ツリー 変化点レビュー',
      },
      progress: {
        buildMatrix: 'マトリクス作成',
        countermeasures: '対策',
        extractChanges: '変更点抽出',
        failureModes: '故障モード',
        normalize: '正規化',
        prefillMatrix: 'AI下書き',
        promoteToDesignChange: '設計変更へ昇格',
        review: 'レビュー',
        reviewChanges: '変更点レビュー',
      },
      stageRun: {
        empty: 'まだ実行履歴はありません。',
        title: '実行履歴',
      },
      staged: {
        exportDraft: 'Draft出力',
        exportReviewed: 'レビュー済み出力',
        exportScored: '採点済み出力',
        generateCountermeasures: '対策候補を生成',
        proceedToFailureModes: '故障モード生成へ進む',
        readinessStatus: '内容状態: {{readiness}} / 未解決 {{blockers}}件',
        targetPartLabel: '対象部品',
      },
      workbenches: {
        countermeasureEmpty: '対策候補はまだありません。',
        countermeasureReviewDescription: '対象原因、作用機序、検証方法、合格基準を一体で確認します。',
        countermeasureReviewTitle: '対策レビュー',
        designChangeEmpty: '変更点候補はまだありません。',
        designChangeReviewTitle: '変更点レビュー',
        failureModeEmpty: '故障モード候補はまだありません。',
        failureModeReviewDescription: 'AIの重大度は候補値です。S/O/Dを確認するまでRPNは確定しません。',
        failureModeReviewTitle: '故障モードレビュー',
        failureModeTargetCount: '故障モード生成対象 {{count}}件',
        statusAccepted: '採用',
        statusAiCandidate: 'AI候補',
        statusDeferred: '保留',
        statusModified: '修正済み',
        statusNeedsInfo: '要確認',
        statusRejected: '却下',
        statusSuperseded: '旧版',
      },
    };

export default workflow;
